var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "@mindbreeze/api-clients", "underscore"], function (require, exports, api_clients_1, underscore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MultiModalImageGenerationService = void 0;
    underscore_1 = __importDefault(underscore_1);
    class MultiModalImageGenerationService {
        constructor(url, application) {
            this.openAIChatCompletionV1BetaClient = new api_clients_1.OpenAIChatCompletionV1BetaClient({
                url: url,
                channelOptions: application.channelOptions,
            });
        }
        generateTextFromImage(completionCreateRequest, imageModel) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, e_1, _b, _c;
                var _d, _e, _f, _g;
                const chatCompletionContentPartImage = {
                    "type": "image_url",
                    "image_url": {
                        "url": imageModel.get("dataURI")
                    }
                };
                if (completionCreateRequest && !((_d = completionCreateRequest.messages) === null || _d === void 0 ? void 0 : _d.length)) {
                    completionCreateRequest.messages = [];
                }
                // Append image_uri to messages if user role message found
                const foundUserRoleMessage = completionCreateRequest.messages.find(item => item.role === 'user');
                if (foundUserRoleMessage && underscore_1.default.isArray(foundUserRoleMessage.content)) {
                    foundUserRoleMessage.content.push(chatCompletionContentPartImage);
                }
                else {
                    // Add in case no user message found
                    completionCreateRequest.messages.push({
                        role: 'user',
                        content: [
                            chatCompletionContentPartImage
                        ]
                    });
                }
                imageModel.set('generating', true);
                const stream = this.openAIChatCompletionV1BetaClient.createStream(completionCreateRequest);
                let generatedDescription = '';
                try {
                    for (var _h = true, stream_1 = __asyncValues(stream), stream_1_1; stream_1_1 = yield stream_1.next(), _a = stream_1_1.done, !_a; _h = true) {
                        _c = stream_1_1.value;
                        _h = false;
                        const tokenEvent = _c;
                        const content = ((_g = (_f = (_e = tokenEvent === null || tokenEvent === void 0 ? void 0 : tokenEvent.choices) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.delta) === null || _g === void 0 ? void 0 : _g.content) || '';
                        generatedDescription += ' ' + content;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_h && !_a && (_b = stream_1.return)) yield _b.call(stream_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                imageModel.set({
                    generatedDescription: generatedDescription,
                    generating: false
                });
                return generatedDescription;
            });
        }
    }
    exports.MultiModalImageGenerationService = MultiModalImageGenerationService;
});
